export default {
  meta: {
    title: '自定义商圈',
  },
};
